'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaults2 = require('lodash/defaults');

var _defaults3 = _interopRequireDefault(_defaults2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _map2 = require('lodash/map');

var _map3 = _interopRequireDefault(_map2);

exports.default = unstack;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unstack(props) {
    var series = props.series,
        seriesNormalized = props.seriesNormalized,
        maxX = props.maxX,
        maxY = props.maxY,
        minX = props.minX,
        minY = props.minY;


    var newSeries = (0, _map3.default)(series, function (series) {
        var newSeries = {
            data: (0, _map3.default)(series.data, function (point) {
                var newPoint = (0, _omit3.default)(point, ['y0', 'y']);
                newPoint.y = point.y - point.y0;
                return newPoint;
            })
        };
        return (0, _defaults3.default)(newSeries, series);
    }, []);

    return {
        series: newSeries,
        seriesNormalized: seriesNormalized,
        maxX: maxX,
        maxY: maxY,
        minX: minX,
        minY: minY
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/rumble-charts/lib/helpers/transforms/unstack.js
 ** module id = 1576
 ** module chunks = 3
 **/